if (!customElements.get("glide-slider-component")) {
    customElements.define(
        "glide-slider-component",
        class extends HTMLElement {
            constructor() {
                super();
                this.slider = this.querySelector(".glide");
                this.slides = this.querySelectorAll(".glide--slide");
                this.sliderId = this.slider?.getAttribute("id");

                console.log(this)

                // Default options (fallback values)
                const defaults = {
                    type: "carousel",
                    perView: 3,
                    gap: 0,
                    startAt: 0,
                    bound: true,
                    breakpoints: {},
                    animationDuration: 500,
                };

                this.sliderOptions = {
                    ...defaults,
                    ...this.buildBaseOptionsFromDataAttributes(),
                };

                this.gliderInstance = null;
                this.currentSettings = {}; // Track current settings to detect changes
                this.setupRequestId = 0;

                // Parse data-breakpoints from the attribute
                this.breakpoints = this.dataset.breakpoints
                    ? JSON.parse(this.dataset.breakpoints)
                    : {};
            }

            connectedCallback() {
                this.waitForVisibility(() => {
                    void this.setupSlider();
                });

                this.boundHandleResize = () => {
                    void this.handleResize();
                };

                window.addEventListener("resize", this.boundHandleResize);
            }

            waitForVisibility(callback) {
                // Check if slider has width (is visible)
                if (this.slider && this.slider.clientWidth > 0) {
                    callback();
                    return;
                }

                // If not visible, wait and check again
                const checkVisibility = () => {
                    if (this.slider && this.slider.clientWidth > 0) {
                        callback();
                    } else {
                        requestAnimationFrame(checkVisibility);
                    }
                };

                // Start checking after small delay
                setTimeout(checkVisibility, 200);
            }

            disconnectedCallback() {
                this.setupRequestId += 1;
                if (this.boundHandleResize) {
                    window.removeEventListener(
                        "resize",
                        this.boundHandleResize
                    );
                }
                this.destroySlider();
            }

            buildBaseOptionsFromDataAttributes() {
                const options = {};

                for (const key in this.dataset) {
                    // Skip breakpoints as it's handled separately
                    if (key === "breakpoints") continue;

                    const value = this.dataset[key];

                    // Dataset already exposes data-* attributes as camelCase keys
                    // (e.g., data-per-view -> perView), so we can use them directly.
                    options[key] = this.parseValue(value);
                }

                return options;
            }

            parseValue(value) {
                // If value is not a string, return as-is (already parsed from JSON)
                if (typeof value !== "string") {
                    return value;
                }

                if (value === "true") return true;
                if (value === "false") return false;

                if (
                    (value.startsWith("{") && value.endsWith("}")) ||
                    (value.startsWith("[") && value.endsWith("]"))
                ) {
                    try {
                        return JSON.parse(value);
                    } catch (e) {
                        return value;
                    }
                }

                const numValue = Number(value);
                if (!isNaN(numValue) && value !== "") {
                    return numValue;
                }

                return value;
            }

            async getGlideConstructor() {
                // Reuse globally-available Glide when another script already loaded it.
                if (window.Glide) {
                    return window.Glide;
                }

                const componentClass = this.constructor;

                if (!componentClass.glideLoadPromise) {
                    componentClass.glideLoadPromise = import(
                        "https://cdn.jsdelivr.net/npm/@glidejs/glide/dist/glide.esm.js"
                    )
                        .then((module) => module?.default || window.Glide)
                        .catch((error) => {
                            if (window.Glide) {
                                return window.Glide;
                            }

                            throw new Error(
                                `Unable to load Glide slider module: ${error?.message || error}`
                            );
                        });
                }

                const Glide = await componentClass.glideLoadPromise;

                if (!Glide) {
                    throw new Error(
                        "Glide slider constructor was not found after loading."
                    );
                }

                return Glide;
            }

            async setupSlider(options = {}) {
                if (options.refreshConfig) {
                    this.breakpoints = this.dataset.breakpoints
                        ? JSON.parse(this.dataset.breakpoints)
                        : {};

                    // Update base slider options from attributes
                    if (this.dataset.type) {
                        this.sliderOptions.type = this.dataset.type;
                        this.sliderOptions.bound = true;
                        this.sliderOptions.rewind = false;
                    }
                    if (this.dataset.gap) {
                        this.sliderOptions.gap = parseInt(this.dataset.gap);
                    }
                    if (this.dataset.perView) {
                        this.sliderOptions.perView = parseFloat(
                            this.dataset.perView
                        );
                    }
                    if (this.dataset.peek) {
                        this.sliderOptions.peek = parseInt(this.dataset.peek);
                    }
                }

                console.log("1", this.sliderId);
                const screenWidth = window.innerWidth;
                const breakpointSettings =
                    this.getCurrentBreakpoint(screenWidth);

                const processedBreakpointSettings = Object.fromEntries(
                    Object.entries(breakpointSettings).map(([key, value]) => {
                        return [key, this.parseValue(value)];
                    })
                );

                console.log("2", this.sliderId);

                const newSettings = {
                    ...this.sliderOptions,
                    ...processedBreakpointSettings,
                };

                const isEnabled =
                    processedBreakpointSettings.enabled === false
                        ? false
                        : true;

                const requestId = ++this.setupRequestId;
                const Glide = await this.getGlideConstructor();

                if (requestId !== this.setupRequestId) {
                    return;
                }

                console.log("3", this.sliderId);

                const settingsChanged =
                    !this.currentSettings.enabled !== !isEnabled ||
                    Object.keys({
                        ...this.currentSettings,
                        ...newSettings,
                    }).some(
                        (key) => this.currentSettings[key] !== newSettings[key]
                    );

                if (this.gliderInstance && (settingsChanged || !isEnabled)) {
                    this.destroySlider();
                }

                console.log("4", this.sliderId);

                if (isEnabled && !this.gliderInstance) {
                    console.log("5", this.sliderId);
                    if (!this.sliderId) throw new Error("slider id is not set");

                    this.gliderInstance = new Glide(
                        `#${this.sliderId}`,
                        newSettings
                    );
                    this.gliderInstance.settings.classes.nav.active =
                        "glide--bullet--active";

                    this.currentSettings = {
                        ...newSettings,
                        enabled: isEnabled,
                    };

                    this.gliderInstance.mount();

                    // Setup slide classes for smooth transitions
                    this.setupSlideClasses();

                    // Setup slide change tracking for video coordination
                    // this.setupSlideChangeTracking();

                    if (this.dataset.forceUpdate !== undefined) {
                        requestAnimationFrame(() => {
                            if (this.gliderInstance) {
                                this.gliderInstance.update();
                            }
                        });
                    }
                }
            }

            setupSlideClasses() {
                if (!this.gliderInstance) return;

                const isCloneSlide = (slide) =>
                    slide?.classList.contains("glide__slide--clone") ||
                    slide?.classList.contains("glide--slide--clone");

                const getSlides = () =>
                    Array.from(
                        this.querySelectorAll(".glide__slide, .glide--slide")
                    );

                const getOriginalSlides = () =>
                    getSlides().filter((slide) => !isCloneSlide(slide));

                const getOriginalSlideByIndex = (index) => {
                    const originalSlides = getOriginalSlides();

                    if (!originalSlides.length) {
                        return null;
                    }

                    const normalizedIndex =
                        ((index % originalSlides.length) +
                            originalSlides.length) %
                        originalSlides.length;

                    return originalSlides[normalizedIndex] ?? null;
                };

                const getPredictedTargetSlide = (move) => {
                    const originalSlides = getOriginalSlides();

                    if (!originalSlides.length) {
                        return null;
                    }

                    const activeIndex = this.gliderInstance.index ?? 0;
                    const steps =
                        typeof move?.steps === "number" && move.steps > 0
                            ? move.steps
                            : 1;

                    if (move?.direction === ">") {
                        return getOriginalSlideByIndex(activeIndex + steps);
                    }

                    if (move?.direction === "<") {
                        return getOriginalSlideByIndex(activeIndex - steps);
                    }

                    if (move?.direction === "=") {
                        const targetIndex =
                            typeof move.steps === "number"
                                ? move.steps
                                : activeIndex;

                        return getOriginalSlideByIndex(targetIndex);
                    }

                    return getOriginalSlideByIndex(activeIndex);
                };

                const setCustomActiveSlide = (targetSlide) => {
                    const slides = getSlides();

                    if (!slides.length) {
                        return;
                    }

                    slides.forEach((slide) => {
                        if (slide === targetSlide) {
                            slide.classList.add("custom-active");
                            slide.dataset.isActive = "true";
                        } else {
                            slide.classList.remove("custom-active");
                            slide.dataset.isActive = "false";
                        }
                    });
                };

                this.setCustomActiveSlide = (targetSlide) => {
                    if (!targetSlide || isCloneSlide(targetSlide)) {
                        return;
                    }

                    setCustomActiveSlide(targetSlide);
                };

                const updateSlideClasses = (move) => {
                    setCustomActiveSlide(getPredictedTargetSlide(move));
                };

                updateSlideClasses();

                this.gliderInstance.on("run.before", updateSlideClasses);
            }

            setupSlideChangeTracking() {
                if (!this.gliderInstance) return;
                // Fire BEFORE slide transition starts via pub/sub
                this.gliderInstance.on("run.before", () => {
                    publish("glide:before:change", {
                        component: this,
                        currentIndex: this.gliderInstance.index,
                    });
                });

                // Fire AFTER slide transition completes via pub/sub
                this.gliderInstance.on("run.after", () => {
                    publish("glide:after:change", {
                        component: this,
                        currentIndex: this.gliderInstance.index,
                    });
                });
            }

            // Expose control methods for video coordination
            pauseAutoplay() {
                if (this.gliderInstance) {
                    this.gliderInstance.pause();
                }
            }

            resumeAutoplay() {
                if (this.gliderInstance && this.dataset.autoplay) {
                    this.gliderInstance.play();
                }
            }

            goToNext() {
                if (this.gliderInstance) {
                    this.gliderInstance.go(">");
                }
            }

            goToSlide(index) {
                if (this.gliderInstance) {
                    this.gliderInstance.go(`=${index}`);
                }
            }

            getCurrentBreakpoint(screenWidth) {
                const breakpointKeys = Object.keys(this.breakpoints)
                    .map(Number)
                    .sort((a, b) => b - a);

                for (const bp of breakpointKeys) {
                    if (screenWidth >= bp) {
                        return this.breakpoints[bp];
                    }
                }
                return {};
            }

            handleResize() {
                return this.setupSlider();
            }

            destroySlider() {
                if (this.slideClassFrame) {
                    cancelAnimationFrame(this.slideClassFrame);
                    this.slideClassFrame = null;
                }

                if (this.gliderInstance) {
                    this.gliderInstance.destroy();
                    this.gliderInstance = null;
                }
            }

            resetGlide() {
                this.destroySlider();
                void this.setupSlider();
            }
        }
    );
}
